import React from 'react';
import { Modal, Typography, Card, Grid, Space, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import { BookOutlined, QuestionCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const DetailModal = ({ item, onClose }) => {
    const { t } = useTranslation();
    const screens = useBreakpoint();

    if (!item) return null;

    return (
        <Modal
            title={
                <Space size={12}>
                    <BookOutlined style={{ fontSize: '24px', color: '#1890ff' }} />
                    <Space direction="vertical" size={0}>
                        <Title level={4} style={{ margin: 0 }}>{item.name}</Title>
                        <Text type="secondary">{item.description}</Text>
                    </Space>
                </Space>
            }
            open={!!item}
            onCancel={onClose}
            width={screens.xs ? '100%' : 800}
            footer={null}
            centered
        >
            <Space direction="vertical" size={12} style={{ width: '100%' }}>
                {item.entries.map((entry, index) => (
                    <Card
                        key={index}
                        size="small"
                        bordered
                    >
                        {entry.type === 'qa' ? (
                            <Space direction="vertical" size={8} style={{ width: '100%' }}>
                                <Space size={8}>
                                    <QuestionCircleOutlined
                                        style={{
                                            color: '#1890ff',
                                            marginTop: '4px',
                                            flexShrink: 0
                                        }}
                                    />
                                    <Text strong>{entry.question}</Text>
                                </Space>
                                <Row>
                                    <Col offset={1}>
                                        <Text>{entry.answer}</Text>
                                    </Col>
                                </Row>
                            </Space>
                        ) : (
                            <Space size={8}>
                                <InfoCircleOutlined
                                    style={{
                                        color: '#52c41a',
                                        marginTop: '4px',
                                        flexShrink: 0
                                    }}
                                />
                                <Text>{entry.content}</Text>
                            </Space>
                        )}
                    </Card>
                ))}
            </Space>
        </Modal>
    );
};

export default DetailModal;
